import { render, staticRenderFns } from "./_wbet.vue?vue&type=template&id=03d94508&lang=pug&"
import script from "./_wbet.vue?vue&type=script&lang=js&"
export * from "./_wbet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports